export default "__VITE_ASSET__DXW7Yhxv__"